import { createSlice } from '@reduxjs/toolkit';
import { PERIODS_2, PERIODS_3, FINANCIAL_STATEMENTS_MENU } from 'Constants';

const initialState = {
  ticker: null,
  tickerInfo: null,
  type: null,
  typ: null,

  tickerDetail: null,
  hasLoadedTicker: false,
  howto: null,
  season: null,

  relativeRate: null,
  financialState: FINANCIAL_STATEMENTS_MENU[0].value,
  financialStatements: null
}

export const stockInit = createSlice({
  name: 'StockInit',
  initialState,
  reducers: {
    setTicker: (state, action) => {
      state.ticker = action.payload;
    },
    setTickerInfo: (state, action) => {
      state.tickerInfo = action.payload;
    },
    setType: (state, action) => {
      state.type = action.payload;
    },
    setTyp: (state, action) => {
      state.typ = action.payload;
    },
    setTickerDetail: (state, action) => {
      state.tickerDetail = action.payload;
      // mark that we've attempted to load ticker detail (even if payload is null)
      state.hasLoadedTicker = true;

      // normalize types: backend may return strings for numeric flags (STK_TYP, CTR_TYP)
      if (state.tickerDetail) {
        if (state.tickerDetail.STK_TYP != null) state.tickerDetail.STK_TYP = Number(state.tickerDetail.STK_TYP);
        if (state.tickerDetail.CTR_TYP != null) state.tickerDetail.CTR_TYP = Number(state.tickerDetail.CTR_TYP);
        if (state.tickerDetail.siseInfo && state.tickerDetail.siseInfo.trdPrc != null) {
          // make sure prices are numbers for comparisons
          state.tickerDetail.siseInfo.trdPrc = Number(state.tickerDetail.siseInfo.trdPrc);
        }
      }

      state.type = PERIODS_2[0]
      state.typ = PERIODS_3[0]

      // 컨센서스 데이터중 실시간 시세가 있는 경우 예외처리
      if (state.tickerDetail && state.tickerDetail.siseInfo && state.tickerDetail.consensus) {
        const trdPrc = state.tickerDetail.siseInfo.trdPrc;
        const trdDd = state.tickerDetail.siseInfo.trdDd;
        const targetPrice = state.tickerDetail.consensus.TARGET_PRICE;
        const minFinlitTarget = state.tickerDetail.consensus.MIN_FINLIT_TARGET;
        const maxFinlitTarget = state.tickerDetail.consensus.MAX_FINLIT_TARGET;

        if (trdPrc > 0) {
          if (trdPrc < targetPrice) {
            state.tickerDetail.consensus.COMMENT = 1;
          } else if (trdPrc > targetPrice) {
            state.tickerDetail.consensus.COMMENT = -1;
          } else {
            state.tickerDetail.consensus.COMMENT = 0;
          }
          state.tickerDetail.consensus.MIN_FINLIT_UPSIDE = (minFinlitTarget-trdPrc)/trdPrc*100;
          state.tickerDetail.consensus.MAX_FINLIT_UPSIDE = (maxFinlitTarget-trdPrc)/trdPrc*100;
          state.tickerDetail.consensus.TRD_DT = trdDd;
        }
      }
    },
    setHowto: (state, action) => {
      state.howto = action.payload;
    },
    setSeason: (state, action) => {
      state.season = action.payload;
    },
    setRelativeRate: (state, action) => {
      state.relativeRate = action.payload;
    },
    setFinancialState: (state, action) => {
      state.financialState = action.payload;
    },
    setFinancialStatements: (state, action) => {
      state.financialStatements = action.payload;
    }
  }
})

// Action creators are generated for each case reducer function
export const { setTicker, setTickerInfo, setType, setTyp, setTickerDetail, setHowto, setSeason, setRelativeRate, setFinancialState, setFinancialStatements } = stockInit.actions;

export default stockInit.reducer;
